export default __webpack_public_path__ + "a3cfa69a4048c8239d101799049cbb36.svg";